import React, { createRef } from "react";
import NavRight from "../../../../../../components/layout/nav/right";
import { useGlobalContext } from "../../../../../../context/global/state";
import { Link, useHistory } from "react-router-dom";
import "../mainNavRightDesktop.scss";
import SmoothDropdown from "components/controllers/shared/smoothDropdown/smoothDropdown";
import ToggleLink from "containers/templates/elements/dropdown/toggleLink";
import MenuContent from "containers/templates/elements/dropdown/menuContent";
import { ReactComponent as UserIcon } from "../assets/userIcon.svg";
import { ReactComponent as MessagesIcon } from "../assets/messagesIcon.svg";
import { ReactComponent as GlobeIcon } from "../assets/globeIcon.svg";
import { ReactComponent as LogoutIcon } from "../assets/logoutIcon.svg";

const Right: React.FC = () => {
	let ref = createRef<HTMLUListElement>();
	const { nav } = useGlobalContext();
	const history = useHistory();
	const siteContext = nav.getSiteContext(history);
	const isMember = siteContext.includes("member");

	return (
		<>
			<NavRight>
				<li className="primaryNavOnItems hidden-xs hidden-sm hidden-md primaryNavOnItems myAccounts">
					<SmoothDropdown id="dropdown-custom-my-accounts">
						<ToggleLink
							className="myAccountsActivator"
							bsRole="toggle"
						>
							<span style={{ position: "relative" }}>
								<span className="profileAvatar">JC</span>
								<span className="notificationIcon"></span>
							</span>
							John Customer
							<i
								className="fa fa-chevron-down util-margin-left-5"
								style={{
									fontSize: "10px",
									marginTop: "-4px",
									verticalAlign: "middle",
								}}
								aria-hidden="true"
							></i>
						</ToggleLink>

						<MenuContent
							additionalClasses="webdemoMyAccountsList"
							bsRole="menu"
						>
							<ul ref={ref} className="myProfileContent">
								<li style={{ marginTop: "10px" }}>
									<Link
										className="myAccountLinks"
										to={
											isMember
												? "/member/profile"
												: "/employer/profile"
										}
										style={{
											maxHeight: "60px",
											textDecoration: "none",
											lineHeight: 1,
										}}
									>
										<UserIcon
											style={{
												marginRight: "10px",
												marginTop: "-3px",
											}}
										/>
										My Profile
									</Link>
								</li>
								<li>
									<Link
										className="myAccountLinks"
										to={
											isMember
												? "/member/messages"
												: "/employer/messages"
										}
										style={{
											maxHeight: "60px",
											textDecoration: "none",
											lineHeight: 1,
										}}
									>
										<MessagesIcon
											style={{
												marginRight: "10px",
												marginTop: "-3px",
											}}
										/>
										Messages
										<span className="messageCount">
											<>{isMember ? 3 : 5}</>
										</span>
									</Link>
								</li>
								{isMember && (
									<li>
										<Link
											className="myAccountLinks"
											to="/member/help"
											style={{
												maxHeight: "60px",
												textDecoration: "none",
												lineHeight: 1,
											}}
										>
											<GlobeIcon
												style={{
													marginRight: "10px",
													marginTop: "-3px",
												}}
											/>
											Help
										</Link>
									</li>
								)}
								<li
									style={{
										borderTop: "1px solid #c5c6c5",
										marginTop: "10px",
									}}
								>
									<Link
										className="myAccountLinks"
										to="/"
										style={{
											maxHeight: "60px",
											textDecoration: "none",
											lineHeight: 1,
											marginTop: "10px",
										}}
									>
										<LogoutIcon
											style={{
												marginRight: "10px",
												marginTop: "-3px",
											}}
										/>
										Log out
									</Link>
								</li>
							</ul>
						</MenuContent>
					</SmoothDropdown>
				</li>
			</NavRight>
		</>
	);
};

export default Right;
